module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-10-db2b07bbf7c93bdd905eaafaf7054e96.svg";